import { Add } from "@mui/icons-material";
import {
  Box,
  Button,
  ButtonBase,
  Checkbox,
  FormControlLabel,
  Skeleton,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { makeDefaultUserCards, removeUserCards } from "slices/cardReducer";
import { useAppDispatch, useAppSelector } from "store/appHooks";

const CardListing = ({ allowManage }: any) => {
  const dispatch = useAppDispatch();
  const { cardReducer } = useAppSelector((state) => state);
  const { loadingCards } = cardReducer;
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        height: "100%",
        // margin: "auto",
        pl: { md: "80px", lg: "80px", xl: "80px", sm: "5px", xs: "5px" },
        pr: { md: "30px", lg: "30px", xl: "30px", sm: "5px", xs: "5px" },
        py: {
          md: "25px",
          lg: "25px",
          xl: "25px",
          sm: "0",
          xs: "0",
        },
        minWidth: { md: "328px", lg: "328px", xl: "328px" },
        // maxWidth: "328px",
        // width: { md: "fit-content", lg: "fit-content", xl: "fit-content" },
        // ...(cardReducer.cards.length === 0 ? { minWidth: "328px" } : {}),
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          p: {
            md: "20px 0 20px 0px",
            lg: "20px 0 20px 0px",
            xl: "20px 0 20px 0px",
            sm: "20px 0 20px 20px",
            xs: "20px 0 20px 20px",
          },
        }}
      >
        <Typography
          sx={{
            color: "#323232",
            fontWeight: 600,
            fontSize: "18px",
            lineHeight: "35px",
          }}
        >
          Credit/Debit card
        </Typography>
        {cardReducer.cards.length > 0 && !allowManage && (
          <Button
            startIcon={<Add />}
            sx={{
              display: {
                md: "none",
                lg: "none",
                xl: "none",
                sm: "flex",
                xs: "flex",
              },
              padding: 0,
              flex: 1,
            }}
            onClick={() => navigate("/saved-cards?goBack=1")}
          >
            Add New Card
          </Button>
        )}
      </Box>
      <Box
        sx={{
          marginLeft: { sm: "20px", xs: "20px", lg: "0", xl: "0", md: "0" },

          display: "flex",
          flex: 1,
          // display: {
          //   md: "flex",
          //   lg: "flex",
          //   xl: "flex",
          //   sm: "",
          //   xs: "",
          // },
          flexDirection: {
            md: "column",
            lg: "column",
            xl: "column",
            sm: "row",
            xs: "row",
          },
          gap: "15px",
          overflow: "auto",
          pb: "10px",

          // margin: "auto",
          // width: "fit-content",
        }}
      >
        {!loadingCards &&
          cardReducer.cards.length > 0 &&
          cardReducer.cards.map((card: any) => (
            <Box>
              <Box
                sx={{
                  background:
                    "url(/assets/img/icons/card_placeholder.svg) right bottom, url(/assets/img/icons/card_map.svg) left top ",
                  height: "176px",
                  width: "328px",
                  minWidth: "328px",
                  maxWidth: "328px",
                }}
              >
                <Box sx={{ padding: "20px" }}>
                  <Box
                    sx={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <img
                      src="/assets/img/icons/visa_color.svg"
                      alt=""
                      width="28"
                      height="24"
                    />
                    <img
                      src="/assets/img/icons/card_chip.svg"
                      alt=""
                      width="28"
                      height="24"
                    />
                  </Box>
                  <Box
                    sx={{
                      mt: "15px",
                      display: "flex",
                      flexDirection: "column",
                      gap: "22px",
                    }}
                  >
                    <Typography
                      sx={{
                        color: "#FFFFFF",
                        fontSize: "18px",
                        fontWeight: 700,
                        lineHeight: "22px",
                        letterSpacing: "2px",
                        textShadow: "1px 2px #0000003D",
                      }}
                    >
                      XXXX XXXX XXXX {card.last_4}
                    </Typography>
                    <Typography
                      sx={{
                        color: "#FFFFFF",
                        fontSize: "13px",
                        fontWeight: 500,
                        lineHeight: "16px",
                        textShadow: "1px 2px #0000003D",
                      }}
                    >
                      {card.card_holder_name}
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "#FFFFFF",
                          fontSize: "13px",
                          fontWeight: 500,
                          lineHeight: "16px",
                        }}
                      >
                        Valid thru: {card.expiry_month}/{card.expiry_year}
                      </Typography>
                      <Typography
                        sx={{
                          color: "#FFFFFF",
                          fontSize: "15px",
                          fontWeight: 700,
                          lineHeight: "18px",
                        }}
                      >
                        CVV
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                sx={{
                  width: "328px",
                  minWidth: "328px",
                  maxWidth: "328px",
                }}
              >
                <FormControlLabel
                  label={card.is_default ? "Default Card" : "Make Default"}
                  control={
                    <Checkbox
                      checked={card.is_default}
                      onChange={({ target }) => {
                        if (!card.is_default)
                          dispatch(makeDefaultUserCards({ id: card.id }));
                        //   dispatch(removeUserCards({ id: card.id }));
                      }}
                      sx={{ padding: "0px" }}
                      checkedIcon={
                        <img src="/assets/img/icons/checked.svg" alt="" />
                      }
                      icon={
                        <img src="/assets/img/icons/unchecked.svg" alt="" />
                      }
                    />
                  }
                  sx={{
                    px: "15px",
                    py: "10px",
                    display: "flex",
                    gap: "8px",
                    span: {
                      color: "#323232",
                      fontSize: "14px",
                      fontWeight: 500,
                    },
                  }}
                />
                {allowManage && (
                  <Box display="flex" gap="20px">
                    <img
                      src="/assets/img/icons/edit-green.svg"
                      alt=""
                      onClick={() => navigate(`/saved-cards?id=${card.id}`)}
                    />
                    {!card.is_default && (
                      <img
                        src="/assets/img/icons/trash_error.svg"
                        alt=""
                        onClick={() =>
                          dispatch(removeUserCards({ id: card.id }))
                        }
                      />
                    )}
                  </Box>
                )}
              </Box>
            </Box>
          ))}

        {loadingCards && (
          <>
            <Skeleton
              variant="rectangular"
              sx={{
                height: "176px",
                width: "328px",
                minWidth: "328px",
                maxWidth: "328px",
                borderRadius: "10px",
              }}
            />
            <Skeleton
              variant="rectangular"
              sx={{
                height: "176px",
                width: "328px",
                minWidth: "328px",
                maxWidth: "328px",
                borderRadius: "10px",
              }}
            />
          </>
        )}
      </Box>

      {!loadingCards && cardReducer.cards.length === 0 && (
        <Box
          width="100%"
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            mt: "20px",
            gap: "10px",
            mb: "30px",
          }}
        >
          <img src="/assets/img/no-cards.png" alt="" width="216px" />
          <Typography
            sx={{ color: "#323232", fontSize: "26px", fontWeight: 700 }}
          >
            Oops! No card{" "}
          </Typography>
          <Typography
            sx={{
              color: "#A2A2A2",
              fontWeight: 500,
              fontSize: "16px",
              maxWidth: "300px",
              textAlign: "center",
            }}
          >
            It seems you haven't added a card yet. Please add a card to complete
            your booking.
          </Typography>

          {!allowManage && (
            <ButtonBase
              sx={{
                width: "90%",
                borderRadius: "10px",
                height: "56px",
                background: "#6E8C20",
                color: "#FFF",
                mt: "20px",
              }}
              onClick={() => navigate("/saved-cards?goBack=1")}
            >
              <Add />
              <Typography sx={{ color: "#FFF", ml: "10px" }}>
                Add New Card
              </Typography>
            </ButtonBase>
          )}
        </Box>
      )}

      {!loadingCards && cardReducer.cards.length > 0 && !allowManage && (
        <Button
          startIcon={<Add />}
          sx={{
            display: {
              md: "flex",
              lg: "flex",
              xl: "flex",
              sm: "none",
              xs: "none",
            },
            padding: 0,
            flex: 1,
            mt: "25px",
          }}
          onClick={() => navigate("/saved-cards?goBack=1")}
        >
          Add New Card
        </Button>
      )}
    </Box>
  );
};

export default CardListing;
